'use strict'

import {createScapiFetch} from './utils'

class TrackOrderMgr {

    constructor(config) {
        this.config = config
        this.fetch = createScapiFetch(config)
    }

    /**
     * Asynchronously tracks an order based on provided parameters.
     *
     * This function constructs a request to track an order using the specified parameters.
     * It validates the input parameters and makes an API call to fetch the order tracking
     * information. If any of the required parameters are missing, or if an error occurs
     * during the API call, it returns an empty object.
     *
     * @param {Object} params - The parameters required to track the order.
     * @param {string} params.orderNo - The order number to be tracked.
     * @param {string} params.email - The email associated with the order.
     * @param {string} params.zipCode - The zip code associated with the order.
     * @param {string} siteId - The site identifier for the API request.
     * @param {string} accessToken - The access token for authenticating the API request.
     * @returns {Promise<Object>} A promise that resolves to the order tracking response object,
     *                            or an empty object if tracking fails or parameters are invalid.
     */
    async trackOrder(params, siteId, accessToken) {
        const {orderNo, email, zipCode} = params

        if (!orderNo || !email || !zipCode || !siteId || !accessToken) {
            return {}
        }

        let urlParam = {
            querystring: {
                c_orderNo: orderNo,
                c_email: encodeURIComponent(email),
                c_zipCode: zipCode
            }
        }

        let endpoint = 'lookup'
        let method = 'GET'
        let args = [urlParam]
        let methodName = 'trackOrder'
        let requestParams = {
            body: null,
            apiPath: 'orders',
            accessToken: accessToken,
            isCached: false,
            siteID: siteId
        }
        let apiVersion = 'v1'
        let trackMyOrderResponse

        try {
            trackMyOrderResponse = await this.fetch(
                endpoint,
                method,
                args,
                methodName,
                requestParams,
                apiVersion
            )

            return trackMyOrderResponse || {}
        } catch (error) {
            return {}
        }
    }
}

export default TrackOrderMgr
